function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".plane-icon-color{fill:#00b2ae;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "plane-icon-color",
  d: "M75.413,12.739a1.134,1.134,0,0,0-1.225-.176L.655,46.729a1.133,1.133,0,0,0-.022,2.045l20.81,10.213a1.133,1.133,0,0,0,1.177-.11L42.854,43.754,26.97,60.093a1.133,1.133,0,0,0-.317.877l1.581,20.6a1.133,1.133,0,0,0,1.988.654l11.045-12.8,13.654,6.524a1.133,1.133,0,0,0,1.569-.683l19.256-61.33A1.133,1.133,0,0,0,75.413,12.739Z",
  transform: "translate(0 -12.458)"
});

function SvgPlaneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75.799,
    height: 70.153,
    viewBox: "0 0 75.799 70.153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneIcon);
export default __webpack_public_path__ + "static/media/plane-icon.028dd8c1.svg";
export { ForwardRef as ReactComponent };